import { ADDMEMBERTIMETRACKER_SUCCESS, ADDMEMBERTIMETRACKER_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const addMemberTimetrackerReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADDMEMBERTIMETRACKER_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case ADDMEMBERTIMETRACKER_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default addMemberTimetrackerReducer;
